import { Dialog } from "@mui/material";
import { useScale, btnDelay } from "common/utils";
import { ParentCloseBtn, FadeTransition } from "common/elements";
import i18n from "features/shared/i18n";
import { ParentPieceReport } from "features/player/types";
import { ParentPieceReportRow } from "./ParentPieceReportRow";

export const PieceReportListModal = ({
  reports,
  onClose,
  onSelectReport,
}: {
  reports: ParentPieceReport[];
  onClose: () => void;
  onSelectReport: (report: ParentPieceReport) => void;
}) => {
  const { scale } = useScale();

  return (
    <Dialog
      fullScreen
      open={true}
      maxWidth={false}
      sx={{ zIndex: 99999 }}
      TransitionComponent={FadeTransition}
      PaperProps={{ style: { backgroundColor: "transparent" } }}
    >
      <div className="flex-col-center w-full h-full bg-textcolor-black/50">
        <div style={{ transform: `scale(${scale})` }}>
          <div className="flex-col-el w-[800px] h-[700px] border-solid border-gray2-30 border-[16px] rounded-[16px] bg-gray2-30">
            <div className="flex-col-el justify-start w-full h-full relative p-6 rounded-[8px] bg-white overflow-hidden">
              <div className="flex-col-el absolute top-0 right-4 w-14 h-14 z-[110]">
                <ParentCloseBtn close={onClose} />
              </div>
              <div className="flex-row-el items-center gap-2 mb-4 pb-3 border-b border-outline shrink-0">
                <span className="material-symbols-outlined !text-[54px] text-red-100">flag</span>
                <h2 className="text-[33px] text-textcolor-black">
                  {i18n.t("MSG_PARENT_PAGE_PLAYER_REPORTS")}
                </h2>
                <span className="text-[24px] text-gray2-100 ml-1">({reports.length})</span>
              </div>

              <div className="flex-col-el flex-1 min-h-0 overflow-y-auto visible-scrollbar">
                <div className="flex-col-el gap-3">
                  {reports.map((report) => (
                    <ParentPieceReportRow
                      key={report.id}
                      report={report}
                      onClick={() => {
                        btnDelay(() => onSelectReport(report));
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
